export default "__VITE_ASSET__DS5rUWRU__"